import httpUtils from '@/utils/http-utils';
import i18n from '@/plugins/vue-i18n';

const baseRequesterOptions = {
  baseUrl: `${window.processEnv.VUE_APP_CMS_API_BASE_URL}/providers`,
  requesterType: 'CMS_WEB_SERVICE',
};
const providerApiReqNotification = httpUtils.createRequester(baseRequesterOptions);
const providerApiReqErrorHandling = httpUtils.createRequester(baseRequesterOptions, 'errorHandling');

const getRequester = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return providerApiReqErrorHandling;
  }

  return providerApiReqNotification;
};

class ProviderApi {
  fetchProviders(type, filters = {}, errorManagementType) {
    return getRequester(errorManagementType)
      .get('/elastic', {
        headers: {
          'accept-language': i18n.locale,
        },
        params: {
          page: filters.page,
          size: filters.size,
          type,
          portausCompanyId: filters.portausCompanyId,
          a: filters.attributes,
          c: filters.countries,
          r: filters.regions,
          t: filters.text,
          sortByOrigin:'ASC'
        },
      }).then(res => res && res.data);
  }

  fetchProvider(id, idType, errorManagementType) {
    return getRequester(errorManagementType)
      .get(`/${id}`, {
        headers: {
          'accept-language': i18n.locale,
        },
        params: {
          idType,
        },
      }).then(res => res && res.data);
  }
}

export default new ProviderApi();
